import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent {

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(private breakpointObserver: BreakpointObserver, private router: Router) {}

    public goto(route) {
        this.router.navigate([route]);
    }

    imageObject: Array<object> = [{
        image: 'assets/reel/64228736.jpg',
        thumbImage: 'assets/reel/thumb/64228736.jpg',        
    }, {
        image: 'assets/reel/64243389.jpg',
        thumbImage: 'assets/reel/thumb/64243389.jpg',
    },{
        image: 'assets/reel/64279206.jpg',
        thumbImage: 'assets/reel/thumb/64279206.jpg',
    },{
        image: 'assets/reel/64310175.jpg',
        thumbImage: 'assets/reel/thumb/64310175.jpg',
    },{
        image: 'assets/reel/64316434.jpg',
        thumbImage: 'assets/reel/thumb/64316434.jpg',
    },{
        image: 'assets/reel/64320816.jpg',
        thumbImage: 'assets/reel/thumb/64320816.jpg',
    },{
        image: 'assets/reel/64323544.jpg',
        thumbImage: 'assets/reel/thumb/64323544.jpg',
    },{
        image: 'assets/reel/64326667.jpg',
        thumbImage: 'assets/reel/thumb/64326667.jpg',
    },{
        image: 'assets/reel/64453518.jpg',
        thumbImage: 'assets/reel/thumb/64453518.jpg',
    },{
        image: 'assets/reel/64481448.jpg',
        thumbImage: 'assets/reel/thumb/64481448.jpg',
    },

    {
        image: 'assets/reel/64492138.jpg',
        thumbImage: 'assets/reel/thumb/64492138.jpg',
    }, {
        image: 'assets/reel/64510636.jpg',
        thumbImage: 'assets/reel/thumb/64510636.jpg',
    },{
        image: 'assets/reel/64531053.jpg',
        thumbImage: 'assets/reel/thumb/64531053.jpg',
    },{
        image: 'assets/reel/64555682.jpg',
        thumbImage: 'assets/reel/thumb/64555682.jpg',
    },{
        image: 'assets/reel/64670228.jpg',
        thumbImage: 'assets/reel/thumb/64670228.jpg',
    },{
        image: 'assets/reel/64707809.jpg',
        thumbImage: 'assets/reel/thumb/64707809.jpg',
    },{
        image: 'assets/reel/64727458.jpg',
        thumbImage: 'assets/reel/thumb/64727458.jpg',
    },{
        image: 'assets/reel/64326667.jpg',
        thumbImage: 'assets/reel/thumb/64326667.jpg',
    },{
        image: 'assets/reel/64453518.jpg',
        thumbImage: 'assets/reel/thumb/64453518.jpg',
    },{
        image: 'assets/reel/64729002.jpg',
        thumbImage: 'assets/reel/thumb/64729002.jpg',
    },
    ];

    public imageSize: {
        width:'205px',
        height: '150px',
        space: 0,
    }
}
